export const isTokenExist = () => !!localStorage.getItem('token');
